import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Categories from "./categories/Categories";
import Offers_Slider from "./offers_slider/Offers_Slider";
import New_Arrival from "./new_arrival/New_Arrival";
import Shop_By_Material from "./shop_by_material/Shop_By_Material";
import Why_Choose from "./why_choose/Why_Choose";
import Ten_Years from "./ten_years/Ten_Years";
import Counter from "./counter/Counter";
import Premium_Quality from "./premium_quality/Premium_Quality";
import Unique_Collection from "./unique_collection/Unique_Collection";
import Cutting_Edge from "./cutting_edge/Cutting_Edge";
import Global_Presence from "./global_presence/Global_Presence";
import Trusted_By_Million from "./trusted_by_million/Trusted_By_Million";
import Reviews from "./reviews/Reviews";
import Home_Blogs from "./home_blogs/Home_Blogs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getRating } from "../../features/home/homeSlice";
import { getblog } from "../../features/blog/Slice";
import Video_Section from "./video-section/Video_Section";
import Manufacturing_Video from "./manufacturing_video/Manufacturing_Video";

function Home() {
  const dispatch = useDispatch();

  const ratings = useSelector((state) => state?.home?.rating);
  useEffect(() => {
    dispatch(getRating());
  
  }, []);
  // console.log(ratings,"ratingsssss")

  return (
    <>
      <Banner />
      <Categories />
      <Offers_Slider />
      <New_Arrival />
      <Video_Section/>
      <Shop_By_Material />
      <Why_Choose />
      <Ten_Years />
      <Counter />
      <Premium_Quality />
      <Unique_Collection />
      <Cutting_Edge />
      <Global_Presence />
      <Trusted_By_Million />
      {ratings?.length > 0 && <Reviews ratings={ratings} />}
      <Manufacturing_Video />
      <Home_Blogs/>
    </>
  );
}

export default Home;
